export default __webpack_public_path__ + "171a79e97512a5724ba38450cc2a1ebc.svg";